import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    LOADING: false,
    isAndroid: false,
    loadingNum: 0
  },
  mutations: {
    showLoading(state) {
      state.LOADING = true
    },
    hideLoading(state) {
      state.LOADING = false
    },
    addLoadingNum(state) {
      state.loadingNum++
    },
    subLoadingNum(state) {
      state.loadingNum--
    },
    setIsAndroid(state, data) {
      state.isAndroid = data
    }
  },
  actions: {
  },
  modules: {
  }
})
